import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onlinemap-2022',
  templateUrl: './onlinemap.component.html',
  styleUrls: ['./onlinemap.component.styl']
})
export class OnlinemapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
